var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 0H56C53.8783 0 51.8434 0.842856 50.3431 2.34315C48.8429 3.84344 48 5.87827 48 8V48H8C5.87827 48 3.84344 48.8429 2.34315 50.3431C0.842856 51.8434 0 53.8783 0 56V184C0 186.122 0.842856 188.157 2.34315 189.657C3.84344 191.157 5.87827 192 8 192H136C138.122 192 140.157 191.157 141.657 189.657C143.157 188.157 144 186.122 144 184V144H184C186.122 144 188.157 143.157 189.657 141.657C191.157 140.157 192 138.122 192 136V8C192 5.87827 191.157 3.84344 189.657 2.34315C188.157 0.842856 186.122 0 184 0V0ZM176 128H144V56C144 53.8783 143.157 51.8434 141.657 50.3431C140.157 48.8429 138.122 48 136 48H64V16H176V128Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.97809a315c00a596c7e5fd3d5b6e3f44.svg";
export { ForwardRef as ReactComponent };